export const authorsCopy = {
  nav: "Author",
  by: "oleh",
  empty: "Profil author sedang disiapkan. Sementara itu, lihat katalog kami.",
  noProducts: "Belum ada produk yang terbit dari author ini.",
  viewProfile: "Lihat profil",
  aboutTitle: "Tentang",
  linksLabel: "Profil di tempat lain",
  notFoundTitle: "Author tidak ditemukan",
  notFoundDescription: "Profil ini mungkin sudah tidak tersedia.",
  backToList: "Lihat semua author",
  breadcrumbHome: "Beranda",
} as const;
